import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles.css'
import { App } from './App'
import { FournisseurAuth } from './lib/auth'
import { demarrerSynchronisation } from './lib/sync'

demarrerSynchronisation()

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <FournisseurAuth>
      <App />
    </FournisseurAuth>
  </StrictMode>
)
